import { render, staticRenderFns } from "./AlarmHistory.vue?vue&type=template&id=71b3979d&scoped=true&"
import script from "./AlarmHistory.vue?vue&type=script&lang=ts&"
export * from "./AlarmHistory.vue?vue&type=script&lang=ts&"
import style0 from "./AlarmHistory.vue?vue&type=style&index=0&id=71b3979d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b3979d",
  null
  
)

export default component.exports